import React, { useState } from 'react'
import styles from "../ManageStateForm.styles"
import SelectDropdown from '../../../../../components/dropdown/selectdropdown/SelectDropdown'
import Popup from '../../../../../components/popup/Popup'
import Button from '../../../../../components/button/Button'
import commonStyles from "../../ManageForms.styles"
import { BUTTON_TYPE } from '../../../../../components/button/constants'
import HorizontalSeparator from '../../../../../components/separator/horizontalSeparator/HorizontalSeparator'
import CheckboxWLabel from '../../../../../components/checkbox/checkboxwlabel/CheckboxWLabel'

const DownloadAllPdf = ({ isPopupOpen, onCloseCb, title = "View/Print Form", options = [], onSubmitCb = () => { },checkboxValues = {}, onChangeCheckBoxCb = () => { } }) => {

    const [selectedOption, setSelectedOption] = useState({ label: "", value: "" })

    const CHECKBOX_NAME_TEXTS = {
        MERGE_COPIES: 'mergeCopies'
    }

    return (
        <Popup
            title={title}
            isPopupOpen={isPopupOpen}
            onCloseCb={onCloseCb}
            childrenStyles={styles.childrenStyles}
        >
            <SelectDropdown
                label='Select State'
                name="States"
                value={selectedOption}
                options={options}
                dropdownMenuStyle={styles.dropdownMenu}
                onSelectCb={(name, newOption) => setSelectedOption(newOption)}
            />
            <HorizontalSeparator />
            <div style={styles.checkboxContainer}>
                <CheckboxWLabel label="Merge Copies" name={CHECKBOX_NAME_TEXTS.MERGE_COPIES} checked={checkboxValues[CHECKBOX_NAME_TEXTS.MERGE_COPIES]} onChangeCb={onChangeCheckBoxCb} />
            </div>
            <div style={styles.buttonsContainer}>
                <Button style={commonStyles.button} onClickCb={() => onSubmitCb(selectedOption)}>Submit</Button>
                <Button style={commonStyles.button} type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={onCloseCb}>Cancel</Button>
            </div>
        </Popup>
    )
}

export default DownloadAllPdf
